import * as Sentry from '@sentry/vue';
export const initSentry = function (app, router) {
  const MODE = import.meta.env.MODE;

  const reg = /(\.test|\.prod)/i;
  if (!reg.test(MODE)) return;
  let { version, env } = window.__INITIAL_STATE__;

  Sentry.init({
    app,
    dsn: 'https://06eca0b700414ce38202d08c87d5ea52@sentry.coros.com/5',
    environment: env,
    release: version,
    tracesSampleRate: 1.0,
    debug: false,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
        // tracingOrigins: ['localhost', 'my-site-url.com', /^\//]
      })
    ]
  });
};
